import type { WorldWeight } from '@mcpanel/core';
import { api } from '../api/client';
import { usePoll } from '../hooks/usePoll';
export function PlacementFields({
  weight,
  preferredNode,
  onChange,
}: {
  weight: WorldWeight;
  preferredNode?: string;
  onChange: (weight: WorldWeight, preferredNode?: string) => void;
}) {
  const nodes = usePoll(() => api.nodes(), 30000);
  return (
    <div className="stack">
      <div className="field">
        <label htmlFor="placement-weight">サーバーの重さ</label>
        <select
          id="placement-weight"
          className="input"
          value={weight}
          onChange={(e) => onChange(e.target.value === 'light' ? 'light' : 'heavy', preferredNode)}
        >
          <option value="heavy">重い</option>
          <option value="light">軽い</option>
        </select>
      </div>
      <div className="field">
        <label htmlFor="placement-node">配置ノード</label>
        <select
          id="placement-node"
          className="input"
          value={preferredNode ?? ''}
          onChange={(e) => onChange(weight, e.target.value || undefined)}
        >
          <option value="">自動選択</option>
          {preferredNode && !nodes.data?.some((n) => n.name === preferredNode) && (
            <option value={preferredNode}>{preferredNode}</option>
          )}
          {nodes.data
            ?.filter((n) => n.role !== 'infra')
            .map((n) => (
              <option key={n.name} value={n.name}>
                {n.name}
                {n.online ? '' : '（停止中）'}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
}
